<template>
  <div style=" background: #f0f4f8;">
    <div style="padding: 25px; padding-bottom: 0px; display: flex;justify-content: space-between;">
      <div style="margin:10px; margin-bottom: 0px;">
        <!--<div class="subtitle-2">
          <b>Bugs Evolutivos: </b>
            <a target="_blank" v-if="versao.VERBUGSEVOLUTIVOS" v-for="(bug, i ) in (Array.isArray(versao.VERBUGSEVOLUTIVOS) ? versao.VERBUGSEVOLUTIVOS : Array(versao.VERBUGSEVOLUTIVOS))" :key="i" :href="'https://bug.realtec.com.br/show_bug.cgi?id=' + bug.trim()">
              {{bug}}
            </a>
            <label v-else>Não possui</label>
        </div>-->
        <div class="subtitle-2">
          <b>Bug Avulso: </b>
            <a target="_blank" v-if="versao.VERBUGAVULSO" :href="'https://bug.realtec.com.br/show_bug.cgi?id=' + versao.VERBUGAVULSO.trim()">{{versao.VERBUGAVULSO}}</a>
            <label v-else>Não Possui</label>          
        </div>
        <div class="subtitle-2">
          <b>Observação: </b>
          <label v-if="versao.VEROBSERVACAO" v-html="versao.VEROBSERVACAO.replace(/([0-9]{5,6})/g, `<a class='rltc-link' target='_blank' href='https://bug.realtec.com.br/show_bug.cgi?id=$1'>$1</a>`)"></label>                  
        </div>  
      </div>
      <div>
        <v-btn
          :disabled="!versao.ARQURL"
          color="#88C658"
          class="ma-2 white--text"
          v-clipboard="versao.ARQURL"
          @click="msg = 'Copiado com sucesso.'"
        >
          <v-icon style="margin: 8px" dark>content_copy</v-icon>          
          Copiar Link
        </v-btn>
        <v-btn
          :disabled="!versao.ARQURL"
          color="#88C658"
          class="ma-2 white--text"
          @click="downloadWFile(versao.ARQURL)"
        >
          <v-icon style="margin: 8px" dark>cloud_download</v-icon>
          Download
        </v-btn>
      </div>                
    </div>     

    <div class="containertable" style="display: flex">
      <v-progress-linear v-if="loadingActive" color="#2A5377" style="width: 100%; margin-left: 50px; margin-right: 50px;"
          indeterminate>
      </v-progress-linear>      
      <md-card v-else style="margin: 20px; display: flex; flex-direction: column;">
        <DataTableVersoes v-if="bugsEvolutivos" :bugList="bugsEvolutivos" :loadingActive="loadingActive" :noDataText="noDataText" tituloTabela="Bugs Evolutivos"></DataTableVersoes>
        <DataTableVersoes v-if="bugsCorretivos" :bugList="bugsCorretivos" :loadingActive="loadingActive" :noDataText="noDataText" tituloTabela="Bugs Corretivos"></DataTableVersoes>
        <DataTableVersoes v-if="bugsOutros" :bugList="bugsOutros" :loadingActive="loadingActive" :noDataText="noDataText" tituloTabela="Outros Bugs"></DataTableVersoes>
        <DataTableLiberacoes :versao="versao"></DataTableLiberacoes>
      </md-card>
    </div>
  </div>
</template>
<script>

import * as BugsService from "../../providers/bugzilla.service";
import DataTableVersoes from "./DataTableVersoes";
import DataTableLiberacoes from "./DataTableLiberacoes";

export default {
  props: ["versao", "bugsEvolutivos", "bugsCorretivos", "bugsOutros"],
  data() {
      return {
        loadingActive: true,
        bugs: [],
        noDataText: "Aguarde...",
        headers: [
          {
            text: "Produto",
            value: "bug_id"
          },
          {
            text: "Produto",
            value: "component"
          },
          {
            text: "Versão",
            value: "short_desc"
          },
          {
            text: "Versão Interna",
            value: "priority"
          }
        ]
      }
  },
  components:{
    DataTableVersoes, DataTableLiberacoes
  },
  created() {
    var self = this;

    BugsService.getBugsVersao(self.versao.VERVERSAOINTERNA)
      .then(r => {
        self.bugs = r;

        if (self.bugs){
          if (self.versao.VERBUGSCORRETIVOS)
            self.bugsCorretivos = self.bugs.filter((el) => {
              return (self.versao.VERBUGSCORRETIVOS.indexOf(el.bug_id.toString()) != -1);
            });

          if (self.versao.VERBUGSEVOLUTIVOS)
            self.bugsEvolutivos = self.bugs.filter((el) => {
              return (self.versao.VERBUGSEVOLUTIVOS.indexOf(el.bug_id.toString()) != -1);
            });

          if (self.versao.VERBUGSOUTROS)
            self.bugsOutros = self.bugs.filter((el) => {
              return (self.versao.VERBUGSOUTROS.indexOf(el.bug_id.toString()) != -1);
            });
        }

        self.loadingActive = false;
        self.noDataText = 'Nada foi encontrado.';
      });
  },
  methods: {
    downloadWFile(item) {
      var self = this;
      self.forceFileDownload(item);
    },
    forceFileDownload(item) {
      this.msg = "Seu download começou..";
      var win = window.open(item, "_blank");
    },    
  }  
};
</script>
<style scoped>
.controlstop {
  display: flex;
  justify-content: flex-end;
}
.v-datatable__actions__range-controls {
  color: #000;
}
.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

/*.md-theme-default a:not(.md-button) {
  color: #2b5577 !important;
}*/

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 33px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

</style>